import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api, { apiUrl } from '../lib/api.js';

// Import de justificatifs en masse : upload d'un PDF multi-pages, suivi du traitement,
// confirmation des rapprochements, ZIP des non-rapprochés.

export function useUploadReceiptBatch() {
  return useMutation({
    mutationFn: (file) => {
      const fd = new FormData();
      fd.append('file', file);
      return api.upload('/receipt-batches', fd);
    },
  });
}

export function useReceiptBatch(batchId) {
  return useQuery({
    queryKey: ['receipt-batch', batchId],
    queryFn: () => api.get(`/receipt-batches/${batchId}`),
    enabled: Boolean(batchId),
    // Poll tant que le traitement asynchrone est en cours.
    refetchInterval: (query) =>
      query.state.data?.batch?.status === 'processing' ? 1500 : false,
  });
}

export function receiptPreviewUrl(batchId, itemId) {
  return apiUrl(`/receipt-batches/${batchId}/items/${itemId}/preview`);
}

export function unmatchedZipUrl(batchId) {
  return apiUrl(`/receipt-batches/${batchId}/unmatched.zip`);
}

export function useConfirmReceiptItem(batchId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, transaction_id, entity_id }) =>
      api.post(`/receipt-batches/${batchId}/items/${itemId}/confirm`, {
        transaction_id,
        entity_id,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['receipt-batch', batchId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}

export function useUnmatchReceiptItem(batchId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId) => api.post(`/receipt-batches/${batchId}/items/${itemId}/unmatch`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['receipt-batch', batchId] });
    },
  });
}

export function useCancelReceiptUpload(batchId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId) => api.post(`/receipt-batches/${batchId}/items/${itemId}/cancel-upload`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['receipt-batch', batchId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}

export function useUploadAllMatched(batchId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post(`/receipt-batches/${batchId}/upload-all`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['receipt-batch', batchId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}
